var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlog = function SvgBlog(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 2,
    y: 4,
    width: 20,
    height: 15,
    rx: 3,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C9.10457 11 10 11.8954 10 13V15C10 16.1046 9.10457 17 8 17H6C4.89543 17 4 16.1046 4 15V13C4 11.8954 4.89543 11 6 11H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6C19.3284 6 20 6.67157 20 7.5C20 8.32843 19.3284 9 18.5 9H5.5C4.67157 9 4 8.32843 4 7.5C4 6.67157 4.67157 6 5.5 6H18.5Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11H19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H13C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15H19Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "blog.cf1b7db69d511a814b6e41d7154929c1.svg";